import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const responsabilidadeRepository = RepositoryFactory.get('responsabilidade');

const state = {
  responsabilidades: [],
  loaded: {
    mapeamento: null,
    status: false,
  },
};

const actions = {
  load({ commit }, payload) {
    return new Promise((resolve) => {
      responsabilidadeRepository.getAllByMapeamento(payload.mapeamento, payload.comissao)
        .then((res) => {
          const responsabilidades = res.data;
          commit('SET_RESPONSABILIDADES', responsabilidades);
          resolve();
        });
    });
  },
  setResponsabilidades({ commit }, responsabilidades) {
    return new Promise((resolve) => {
      commit('SET_RESPONSABILIDADES', responsabilidades);
      resolve();
    });
  },
  setLoaded({ commit }, loaded) {
    commit('SET_LOADED', loaded);
  },
};

const getters = {

};

const mutations = {
  SET_RESPONSABILIDADES: (st, responsabilidades) => {
    responsabilidades.sort((a, b) => {
      if (a.id > b.id) { return -1; }
      if (a.id < b.id) { return 1; }
      return 0;
    });

    st.responsabilidades = responsabilidades;
  },
  SET_LOADED: (st, loaded) => {
    st.loaded = loaded;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
